import { PreziTimeframe } from '__generated__/types';
import { Matrix, MatrixItem } from 'common/components/Matrix';
import ImageTile from 'launch/components/ImageTile';
import Mediabox from 'launch/components/Mediabox';
import * as React from 'react';

export interface Props {
    value: string;
    onChange: (value: PreziTimeframe) => void;
}

export interface SummaryProps {
    value: PreziTimeframe;
    startDate: string;
    endDate: string;
}

export class TimeframeSummary extends React.Component<SummaryProps> {
    render() {
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

        switch (this.props.value) {
            case PreziTimeframe.NOT_SURE:
                return __("Not sure. I'd like to chat with my designer");
            case PreziTimeframe.FORTY_EIGHT_HOURS:
                return __('48 hours');
            case PreziTimeframe.ONE_MONTH:
                return __('1 month');
            case PreziTimeframe.ONE_WEEK:
                return __('1 week');
            case PreziTimeframe.TWO_WEEKS:
                return __('2 weeks');
            case PreziTimeframe.SPECIFIC_DATES:
                if (this.props.startDate && this.props.endDate) {
                    return (
                        new Intl.DateTimeFormat('en-US', options).format(
                            new Date(this.props.startDate)
                        ) +
                        ' - ' +
                        new Intl.DateTimeFormat('en-US', options).format(
                            new Date(this.props.endDate)
                        )
                    );
                }
            default:
                return __("Not sure. I'd like to chat with my designer");
        }
    }
}

export default class TimeFrame extends React.Component<Props> {
    render() {
        const imagePath = function(fileName: string) {
            return require(`images/projects/create/${fileName}`);
        };

        const options = [
            {
                key: PreziTimeframe.FORTY_EIGHT_HOURS,
                url: 'calendar_hour.svg',
                title: __('48 hours'),
                label: __('Quick turnaround fees typically apply'),
            },
            {
                key: PreziTimeframe.ONE_WEEK,
                url: 'calendar_1week.svg',
                title: __('1 week'),
                label: '',
            },
            {
                key: PreziTimeframe.TWO_WEEKS,
                url: 'calendar_2weeks.svg',
                title: __('2 weeks'),
                label: '',
            },
            {
                key: PreziTimeframe.ONE_MONTH,
                url: 'calendar_month.svg',
                title: __('1 month'),
                label: '',
            },
            {
                key: PreziTimeframe.SPECIFIC_DATES,
                url: 'calendar_date.svg',
                title: __('Choose a start & end date'),
                label: '',
            },
            {
                key: PreziTimeframe.NOT_SURE,
                url: 'calendar_question.svg',
                title: __("Not sure. I'd like to chat with my designer"),
                label: '',
            },
        ];

        const optionItems = options.map(option => (
            <MatrixItem key={option.key}>
                <Mediabox
                    variations={['linked', 'chameleon']}
                    selected={this.props.value == option.key}
                    onClick={() => this.props.onChange(option.key)}
                >
                    <ImageTile
                        imagePadding={true}
                        url={imagePath(option.url)}
                        title={option.title}
                        label={option.label}
                    />
                </Mediabox>
            </MatrixItem>
        ));

        return (
            <Matrix large={3} medium={2} small={1} staggered={false}>
                {optionItems}
            </Matrix>
        );
    }
}
